export default __webpack_public_path__ + "static/media/qrcode_duotone.ee1d9fd1.svg";